// embed-snippet.ts — the one place the widget's `<script>` tag is built. Both `EmbedSnippet.tsx`
// (the shared snippet-block-plus-Copy-button component) and `FirstRun.tsx` (the Overview
// brand-new hero's "Email the snippet to my developer" mailto body) need the exact same string;
// living here rather than inside the component keeps `EmbedSnippet.tsx` component-only (a
// non-component export from a component file breaks Fast Refresh — eslint's
// `react-refresh/only-export-components`).
//
// The install guides in apps/web/app/lib/install-guides-content.ts show a placeholder version of
// this same shape (SNIPPET_PLACEHOLDER, with YOUR_BOT_ID instead of a real publicId) — web cannot
// import from dashboard, so keep that placeholder in sync with the string built here by hand.
import type { Catalog } from '../locales/en';

export function embedSnippet(publicId: string): string {
  const apiPublicOrigin =
    ((import.meta.env.VITE_API_PUBLIC_ORIGIN as string | undefined) ?? '').trim() ||
    window.location.origin;
  return `<script src="${apiPublicOrigin}/widget.js" data-bot="${publicId}" async></script>`;
}

/** The `mailto:` link `FirstRun.tsx`'s hero renders as "Email the snippet to my developer"
 * (locale-dashboard plan, Task 7) — moved here, next to `embedSnippet` itself, rather than left
 * as an inline template literal in the component: this is already the one place the widget's
 * `<script>` tag is built, and the mailto body embeds that exact snippet, so both live behind one
 * function instead of `FirstRun.tsx` re-deriving the tag string a second time. */
export function mailtoSnippetLink(botName: string, publicId: string, t: Catalog): string {
  const subject = t.overview.emailSnippetSubject({ botName });
  const body = t.overview.emailSnippetBody({ snippet: embedSnippet(publicId) });
  return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
